const config = window.myTalentionConfig;

const GetTranslationOfProperty = (campaignPropertey, value) => {

    let translatedValue = false;
    for (let i = 0; i < config.myFilter.length; i++) {
        let element = config.myFilter[i];
        if (element.name === campaignPropertey && element.options[value]) {
            translatedValue = element.options[value];
        }
    }

    return translatedValue || value;
};

export default GetTranslationOfProperty;
